import React, { useState } from "react";
import styled from "styled-components/macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCheck } from "@fortawesome/free-solid-svg-icons";
import { StyledBlackButton } from "../../ButtonsStyle";
import { questionsWizard, titleWizard } from "./questionsWizard";

const WizardUnitStep4 = ({ onClick, onBackPress, people, propertyKey }) => {
  const properties = questionsWizard.population[propertyKey];
  const title = titleWizard.population[propertyKey];

  const [property, setProperty] = useState(
    people
      ? people.map((item) =>
          properties?.findIndex((e) => e.title === item.title)
        )
      : []
  );

  const _renderProperties = () => {
    return properties.map((item, index) => {
      return (
        <Section
          index={index}
          className={`animate__animated animate__fadeIn`}
          onClick={() => {
            let list = [...property];
            if (!property.includes(index)) {
              list.push(index);
            } else {
              const propertyIndex = property.findIndex((e) => e === index);
              list.splice(propertyIndex, 1);
            }

            setProperty(list);
          }}
          key={item.title}
        >
          <img
            height={150}
            src={property.includes(index) ? item.chosen : item.image}
            alt={"residential"}
          />
          <Title style={{ marginTop: "5px" }} fontSize={20}>
            {item.title.toUpperCase()}
          </Title>
          <Radio>
            {property.includes(index) && (
              <FontAwesomeIcon color={"#13647b"} icon={faCheck} />
            )}
          </Radio>
        </Section>
      );
    });
  };

  return (
    <Wrapper>
      <TitleWrapper>
        <div
          onClick={onBackPress}
          style={{ padding: "10px 20px", cursor: "pointer" }}
        >
          <FontAwesomeIcon size={"lg"} color={"#4b4b4b"} icon={faArrowLeft} />
        </div>
        <Title fontSize={35}>{title}</Title>
      </TitleWrapper>
      <ImagesWrapper>{_renderProperties()}</ImagesWrapper>

      <StyledBlackButton
        disabled={property.length === 0}
        onClick={() => onClick(property.map((i) => properties[i]))}
        style={{
          marginTop: "40px",
          backgroundColor: property.length === 0 ? "#a1a0a0" : "#606060",
          color: "#FFFFFF",
          fontSize: "20px",
          fontFamily: " Manrope,serif",
          padding: "10px 40px",
        }}
      >
        Next
      </StyledBlackButton>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  align-items: center;
  justify-content: center;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

const Radio = styled.div`
  align-items: center;
  justify-content: center;
  position: relative;
  display: flex;
  width: 22px;
  height: 22px;
  border-radius: 2px;
  padding: 4px;
  border: 1px solid #13647b;
`;

const Section = styled.div`
  cursor: pointer;
  align-items: center;
  justify-content: center;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 10px 10px;
  animation-delay: ${({ index }) => 60 * index}ms;
  width: 300px;
`;

const ImagesWrapper = styled.div`
  align-items: start;
  justify-content: center;
  position: relative;
  flex-direction: row;
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

const Title = styled.div`
  padding: 10px 0;
  color: ${({ color = "#4b4b4b" }) => color};
  font-size: ${({ fontSize = 50 }) => fontSize}px;
  white-space: pre-wrap;
  text-align: center;
  font-family: Manrope, serif;
`;
const TitleWrapper = styled.div`
  display: flex;
  position: relative;
  align-items: center;
`;
export { WizardUnitStep4 };
